// Broken Lands island layouts (§31 D3): the map-makers' configs.
//
// **A layout is drawn, not rolled.** The doc puts the map-makers' work in the
// Broken Lands — "the different island configurations they've made" — so a
// layout is a 20×20 mask an author drew, and the seed only picks which one and
// what grows on each island. `#` is ground, `.` is void. Written north-up, as
// a map is read and as Tiled draws it: the first line is the zone's top rank.
//
// A zone row names a layout by index (`ZoneRow`'s sixth field); absent is
// D2's default 4×4 grid, so an older log replays. **Appended, never
// reordered** — the index is in command rows and saves.
//
// A zone smaller than 20×20 crops the mask from its south-west corner.

/** The masks, north-up. Every line 20 characters, 20 lines. */
const LAYOUTS: readonly (readonly string[])[] = [
  // 0 — Archipelago: ragged islands of every size.
  [
    "###..####...###..###",
    "###..####...###..###",
    "##...####.......####",
    ".........##.........",
    "####....####..######",
    "####....####..######",
    ".##..........#####..",
    ".....####.........##",
    "###..####..###....##",
    "###..........###....",
    "###..####....###.###",
    ".....####..........#",
    "##.........######..#",
    "##..###....######...",
    "....###.............",
    "###.......###..#####",
    "###..###..###..#####",
    ".....###.......#####",
    "###........##.......",
    "###..####..##..#####"
  ],
  // 1 — Causeways: long thin islands, read as broken roads.
  [
    "####..####..####..##",
    "####..####..####..##",
    "##..........##......",
    "##..######..##..####",
    "....######......####",
    "###.##..##.####.....",
    "###.##..##.####.###.",
    "###.......####..###.",
    "....####.......####.",
    ".##.####.###........",
    ".##......###..######",
    ".....##.......######",
    "####.##.####........",
    "####....####.##.####",
    "....###......##.####",
    "###.###.####........",
    "###.....####..######",
    "....###.......######",
    "###.###.####.......#",
    "###.....####..#####."
  ]
];

/** How many layouts there are — what `zoneFault` checks an index against. */
export const ISLAND_LAYOUT_COUNT = LAYOUTS.length;

/** Each layout's name, for a reader. */
export const ISLAND_LAYOUT_NAMES: readonly string[] = ["Archipelago", "Causeways"];

/**
 * Is `(dx, dy)` ground in layout `index`? `dx` east and `dy` north of the
 * zone's south-west corner; outside the mask is void.
 */
export function islandGround(index: number, dx: number, dy: number): boolean {
  const mask = LAYOUTS[index];
  if (!mask || dx < 0 || dy < 0 || dy >= mask.length) return false;
  const line = mask[mask.length - 1 - dy];
  return dx < line.length && line[dx] === "#";
}
